import { render, staticRenderFns } from "./privatereferral.vue?vue&type=template&id=207405e2"
import script from "./privatereferral.vue?vue&type=script&lang=js"
export * from "./privatereferral.vue?vue&type=script&lang=js"
import style0 from "./privatereferral.vue?vue&type=style&index=0&id=207405e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports